import { separarPorMayuscula } from "../../../Commons/Scripts/Utils/formatear";

export const formatData = (data, modulos) => {
  const listData = [];
  if (data?.length > 0 && modulos?.length > 0) {
    let keyCounter = 0;
    let idEntidad = 0;
    for (let modulo in modulos) {
      const listEntidades = [];
      const funcionModulo = `${modulos[modulo].Funcion}`;
      const moduloLabel = modulos[modulo].Nombre;
      const moduloMenu = modulos[modulo].FuncionMenu;

      const hijosModulo = data
        .filter(
          (funcion) =>
            funcion.Nombre.includes(funcionModulo) &&
            !funcion.Nombre.startsWith("Menu.") &&
            !funcion.Nombre.startsWith("Citrus.Menu.")
        )
        .map((funcion, index, arr) => {
          const key = index;
          const entidadNombre = funcion.Nombre.split(".").slice(-2, -1)[0];
          if (!listEntidades.some((e) => e.Entidad === entidadNombre)) {
            listEntidades.push({
              Nombre: separarPorMayuscula(entidadNombre),
              Entidad: entidadNombre,
              Menus: data
                .filter(
                  (e) =>
                    e.Nombre.startsWith("Menu") ||
                    e.Nombre.startsWith("Citrus.Menu")
                )
                .filter((e) => {
                  const modulo = funcionModulo.split(".").pop();

                  const entidadPattern =
                    entidadNombre === "Factura"
                      ? `(Factura|FacturaRapida)`
                      : entidadNombre;

                  const pattern = new RegExp(
                    `^(Menu|Citrus\\.Menu)\\.${modulo}\\.${entidadPattern}(\\..*)?$`
                  );

                  return pattern.test(e.Nombre);
                }),
              Funciones: arr
                .filter(
                  (e) =>
                    e.Nombre.split(".").at(2) === entidadNombre &&
                    !e.Nombre.startsWith("Menu.") &&
                    !e.Nombre.startsWith("Citrus.Menu")
                )
                .map((e) => ({
                  ...e,
                  FuncionCompleta: e.Nombre.split(".").slice(3).join(" "),
                  Funcion: e.Nombre.split(".").pop(),
                  Entidad: entidadNombre,
                  data: e.Nombre,
                  Modulo: funcionModulo,
                  Agregada: e.Agregada,
                })),
            });
          }
          return {
            ...funcion,
            key,
            Entidad: entidadNombre,
            Funcion: funcion.Nombre.split(".").slice(3).join(" "),
            data: funcion.Nombre,
            Modulo: funcionModulo,
            Agregada: funcion.Agregada,
          };
        });

      listData.push({
        key: keyCounter,
        label: moduloLabel,
        children: hijosModulo,
        entidadesHijo: listEntidades
          .map((e) => {
            idEntidad++;
            return { ...e, Id: idEntidad };
          })
          .sort((a, b) =>
            a.Nombre < b.Nombre ? -1 : a.Nombre > b.Nombre ? 1 : 0
          ),
        Funcion: funcionModulo,
        FuncionMenu: moduloMenu,
      });
      keyCounter++;
    }

    const funcionesConModulo = listData.flatMap((m) =>
      m.children?.map((f) => f.IdSec)
    );

    const funcionesSinModulo = data
      .filter(
        (f) =>
          !funcionesConModulo.includes(f.IdSec) &&
          !f.Nombre.startsWith("Menu.") &&
          !f.Nombre.startsWith("Citrus.Menu")
      )
      .sort((a, b) => (a.Nombre < b.Nombre ? -1 : a.Nombre > b.Nombre ? 1 : 0))
      .map((f) => {
        let funcion;
        let funcionCompleta;
        if (
          f.Nombre.startsWith("Citrus.C.") ||
          f.Nombre.startsWith("Citrus.D.")
        ) {
          funcion = f.Nombre.split(".").at(2);
          funcionCompleta = f.Nombre.split(".").slice(4).join(" ");
        } else {
          funcion = f.Nombre.split(".").pop();
          funcionCompleta = f.Nombre.split(".").slice(2).join(" ");
        }
        return {
          ...f,
          data: f.Nombre,
          Funcion: funcion,
          FuncionCompleta: funcionCompleta,
        };
      });

    const entidades = [];

    for (const funcion of funcionesSinModulo) {
      let entidad;
      let cuerpoFuncion;
      if (
        funcion.Nombre.startsWith("Citrus.C.") ||
        funcion.Nombre.startsWith("Citrus.D.")
      ) {
        entidad = funcion.Nombre.split(`.`).at(2);
        cuerpoFuncion = funcion.Nombre.split(".").at(2);
      } else {
        entidad = funcion.Nombre.split(`.`).at(1);
        cuerpoFuncion = funcion.Nombre.split(".").slice(1, 4).join(".");
      }

      if (!entidades.some((e) => e.Entidad === entidad)) {
        idEntidad++;
        entidades.push({
          Id: idEntidad,
          Nombre: separarPorMayuscula(entidad),
          Entidad: entidad,
          Funciones: funcionesSinModulo.filter((f) => {
            let nombre = f.Nombre;
            if (
              (nombre.startsWith("Citrus.C.") ||
                nombre.startsWith("Citrus.D.")) &&
              nombre.split(".").at(2) === entidad
            ) {
              return true;
            } else {
              if (nombre.split(".").at(1) === entidad) {
                return true;
              }
              return false;
            }
          }),
          Menus: data
            .filter(
              (e) =>
                e.Nombre.startsWith("Menu") ||
                e.Nombre.startsWith("Citrus.Menu")
            )
            .filter((e) => {
              if (e.Nombre.includes(cuerpoFuncion)) {
                return true;
              }
              return false;
            }),
        });
      }
    }

    listData.push({
      key: keyCounter,
      label: "Otros",
      esOtros: true,
      children: funcionesSinModulo,
      entidadesHijo: entidades,
    });
  }
  return listData;
};
